<template>
  <ConfirmDialog
      v-model="dialog"
      @update:agree="agree"
      @update:cancel="cancel"
      ref="confirm"
  >
    <template v-slot:title>
      {{ title ? $t(title) : title }}
    </template>
    <template v-slot:content>
        <v-card-text class="pa-4 text-black">
          <v-card-text
              v-show="options.additionalText"
              class="mb-4 pa-0"
          >
            {{ $t(options.additionalText) }}
          </v-card-text>

          <v-form v-model="valid" ref="form">
            <TextArea
              v-model="inputValue"
              :rules="options.rules"
              :label="options.placeholder"
              :class="{ 'not-required': !options.required }"
            />
          </v-form>
        </v-card-text>
    </template>
  </ConfirmDialog>
</template>

<script>
import TextArea from "@intec/vue-components/form/TextArea.vue";
import ConfirmDialog from "@intec/vue-components/form/ConfirmDialog.vue";

// @todo желательно перенести во vue-components
export default {
  name: 'ConfirmInputDlg',
  components: {
    TextArea,
    ConfirmDialog,
  },
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      inputValue: '',
      title: null,
      valid: true,
      options: {
        required: false,
        placeholder: '',
        rules: [],
        additionalText: null,
      },
    };
  },
  methods: {
    open(title, options = {}) {
      this.dialog = true;
      this.title = title;
      this.inputValue = '';
      this.options = Object.assign({}, this.options, options);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      if (this.$refs.form.validate()) {
        this.dialog = false;
        this.resolve({
          confirmed: true,
          value: this.inputValue,
        });
      }
    },
    cancel() {
      this.dialog = false;
      this.resolve({
        confirmed: false,
        value: null,
      });
    },
  },
};
</script>
<style scoped>
:deep(.v-label::after) {
  content: ' *';
  color: rgba(var(--error-color));
}

:deep(.not-required .v-label::after) {
  content: '';
  color: transparent;
}

:deep(.v-expansion-panel-title) {
  font-weight: 500;
  font-size: 18px;
}

:deep(.v-expansion-panel-title--active) {
  background-color: #F5F5F5;
}

:deep(.v-expansion-panel-text) {
  font-size: 16px;
  font-weight: 400;
  padding-left: 10px;
  word-wrap: break-word;
  white-space: normal
}

:deep(.v-field--focused.v-field--variant-underlined .v-field__outline::after) {
  transform: scaleX(0);
}

:deep(.v-field.v-field--focused .v-field__outline) {
  --v-field-border-opacity: 0.38;
}

@media (hover: hover) {
  :deep(.v-field:hover .v-field__outline) {
    --v-field-border-opacity: 0.38;
  }
}
</style>
